// /client/src/components/PrepareExperience.js
import React from 'react';
import NavigationPdfs from './NavigationPdfs';
import FooterPdfs from './FooterPdfs';

const PrepareExperience = () => {
  return (
    <>
      <div className="fullHeight is-flex is-flex-direction-column is-align-items-center is-justify-content-space-between">
        <div className='fullWidth'>
            <NavigationPdfs />
            <div className="pt-2 columns is-centered">
                <div className="column is-6-tablet is-5-desktop is-5-widescreen">
                    <div className="px-4 py-5">
                        <h1 className="h1 colorBlack is-bold">Prepare for your Next Move Experience</h1>
                        <h2 className='h2 is-bold'>Introduction</h2>
                        <p className="pb-4 colorBlack">
                            We are living in a time of great uncertainty, complexity, and rapid change. In this environment, it's easy to feel overwhelmed, stuck, lonely, or unsure about where you are headed.
                        </p>
                        <p className="pb-4 colorBlack">
                            We need new approaches for navigating life—ones that enable us to feel centered, connected, and confident in our choices. We created Next Move to address this need and help you move forward in life with a greater sense of well-being.
                        </p>
                        <p className="pb-4 colorBlack">
                            With The Next Move Method & Next Move Toolkit, you will develop the skills you need to make life feel less stressful and more enjoyable. Our process fosters a community of support and accountability that propels you forward, enabling you to gain momentum on the things that matter to you.
                        </p>
                        <p className="pb-4 colorBlack">
                            Let's reach your goals. Together.
                        </p>
                        <p className="pb-4 colorBlack">
                            Click the download button below to view the optional reading. 
                        </p>
                        <div className="py-5 field">
                            <a 
                                href="/pdfs/next-move-prepare-for-your-next-move-experience.pdf"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="button"
                                download
                            >
                                Download PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       <FooterPdfs />
      </div>
    </>
  );
};

export default PrepareExperience;